import { render, staticRenderFns } from "./ScoreboardChapter.vue?vue&type=template&id=2b461ca2&"
import script from "./ScoreboardChapter.vue?vue&type=script&lang=js&"
export * from "./ScoreboardChapter.vue?vue&type=script&lang=js&"
import style0 from "./ScoreboardChapter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VIcon,VSimpleTable})
